import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid2 as Grid,
  Radio,
  Stack,
  Typography,
} from "@mui/material";
import {
  createProfileReq,
  getUpdatedDetailsReq,
} from "../../../../../redux/specialist-slices/auth.slice";
import {
  requiredFields,
  specializationComponents,
  validationField,
} from "./data";
import InputField1 from "../../../../../components/ui/InputField1";
import SelectInput from "../../../../../components/ui/SelectInput";
import { validateNumber } from "../../../../../utils/velidations";
import FileInput from "../../../../../components/ui/FileInput";
import { useDispatch, useSelector } from "react-redux";
import { currencies } from "../data";
import { red } from "@mui/material/colors";
import ContactInfo from "./ContactInfo";
import { useState } from "react";
import { useRef } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../../../hooks/useToast";
import RadioInput1 from "../../../../../components/ui/RadioBtn";
import Address from "./Address";
function Profile({ handleChange }) {
  const currency = useRef("");
  const timezone = useRef("");
  const countryRef = useRef("");
  const stateRef = useRef("");
  const cityRef = useRef("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const { specialist } = useSelector((state) => state.specialistSlice);
  const toast = useToast();
  const files = useRef({
    profilePhoto: specialist?.profile?.profilePhoto || "",
    clientDemographics: specialist?.profile?.clientDemographics || [],
    specializationArea: specialist?.profile?.specializationArea || [],
    additionalCertificates: specialist?.profile?.additionalCertificates || [],
    ceritificationDocuments: specialist?.profile?.ceritificationDocuments || [],
    specializationCertificate:
      specialist?.profile?.specializationCertificate || [],
  });

  const handleSpecializationArea = (_, value) => {
    files.current.specializationArea = value;
  };

  // Handle add experties
  const handleSubmit = (e) => {
    e.preventDefault();
    const err = {};
    const form = new FormData(e.target);
    let formData = Object.fromEntries(form);
    formData.currency = currency?.current?.value?.value;
    formData.timeZone = timezone?.current?.value?.value;
    formData.country = countryRef?.current?.value?.name || specialist?.address?.country;
    formData.state = stateRef?.current?.value?.name || specialist?.address?.state;
    formData.city = cityRef?.current?.value?.name || specialist?.address?.city;
    // Merge files.current with formData
    formData = {
      ...files.current,
      ...formData,
    };

    // Availability validation (must be >= current date-time)
    // Availability validation (must be >= current date-time)
    if (formData.availability) {
      const selectedDate = moment(formData.availability);
      const now = moment();
      if (selectedDate.isBefore(now)) {
        err.availability = true;
      }
    }


    // Check if profilePhoto is empty, null, undefined, or an empty array
    const hasNewProfilePhoto =
      formData.profilePhoto &&
      (Array.isArray(formData.profilePhoto)
        ? formData.profilePhoto.length > 0
        : formData.profilePhoto);

    if (!hasNewProfilePhoto && specialist?.profile?.profilePhoto) {
      formData.profilePhoto = specialist.profile.profilePhoto;
    }

    formData.specializationArea = formData?.specializationArea?.map(
      ({ _id }) => _id
    );
    const validation = [
      ...requiredFields,
      ...(Array.isArray(validationField?.[specialist?.experties?.specializationId])
        ? validationField[specialist.experties.specializationId]
        : []),
    ];


    validation.forEach((field) => {
      if (!field?.optional) {
        const value = formData[field?.name];

        // Special handling for profilePhoto - don't validate if we have existing photo
        if (field.name === "profilePhoto") {
          const currentPhoto =
            formData.profilePhoto || specialist?.profile?.profilePhoto;
          if (
            !currentPhoto ||
            (Array.isArray(currentPhoto) && currentPhoto.length === 0)
          ) {
            err[field?.name] = true;
          } else {
            delete err[field?.name];
          }
        } else if (Array.isArray(value)) {
          if (!value?.length) {
            err[field?.name] = true;
          } else {
            delete err[field?.name];
          }
        } else {
          if (value?.trim() === "" || !value) {
            err[field?.name] = true;
          } else {
            if (!err[field?.name]) {
              if (value?.trim() === "" || !value) {
                err[field?.name] = true;
              }
            }
          }

        }
      }
    });

    if (formData.zip) {
      const zipClean = formData.zip.trim();
      const zipPattern = /^\d{5,6}$/;
      if (!zipPattern.test(zipClean)) {
        err.zip = "Zip code must be 5 or 6 digits";
      }
    }

    const filteredData = {};
    validation?.forEach(({ name }) => {
      filteredData[name] = formData[name];
    });

    setErrors(err);
    if (!Object.keys(err)?.length) {
      toast.success("Expertise data updated successfully!");

      dispatch(createProfileReq(filteredData))
        .unwrap()
        .then((response) => {
          dispatch(getUpdatedDetailsReq());
          navigate("/specialist/profile");
        })
        .catch((error) => {
          console.error("Profile update error:", error);
        });
    }
  };

  const SpecializationComponents =
    specializationComponents?.[specialist?.experties?.specializationId];
  return (
    <Box
      sx={{
        p: 3,
        border: "1px solid #3498db",
        borderTop: "none",
        borderRadius: "0 0 6px 6px",
      }}
    >
      <Typography
        mb={2}
        fontSize={36}
        component="h2"
        fontWeight="700"
        color="other.color1"
      >
        Create Your Professional Profile
      </Typography>
      <Typography
        mb={1.7}
        fontSize={24}
        component="h4"
        fontWeight="600"
        color="other.color1"
      >
        Help potential clients know you better by setting up your profile. Add
        your bio, photo, and the services you offer
      </Typography>

      <Grid
        container
        rowSpacing={2}
        columnSpacing={1}
        component="form"
        onSubmit={handleSubmit}
      >
        <>
          <Grid size={12}>
            <InputField1
              type="textarea"
              errors={errors}
              name="professionalBio"
              label="Professional Bio *"
              errText="Please enter professional bio"
              defaultValue={specialist?.profile?.professionalBio || ""}
              placeholder="Share a bit about your background, experience, and what clients can expect when working with you."
            />
          </Grid>
          <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
            <FileInput
              files={files}
              errors={errors}
              name="profilePhoto"
              label="Profile Photo *"
              errText="Please upload profile photo"
              placeholderText="Upload a professional photo that represents you"
              defaultValue={specialist?.profile?.profilePhoto || []}
            />
          </Grid>
          <Grid size={12}>
            <InputField1
              type="textarea"
              errors={errors}
              name="description"
              label="Service Description *"
              errText="Please enter service description"
              defaultValue={specialist?.profile?.description || ""}
              placeholder="Describe the services you offer and what clients can expect."
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <SelectInput
              ref={currency}
              name="currency"
              label="Currency *"
              options={currencies}
              renderValueKey="name"
              select="Select type:-"
              varianttype="selectType1"
              selectLabel="Select currency"
              defaultValue={currencies.find(
                ({ value }) => specialist?.profile?.currency === value
              )}
            />
            {errors?.currency && (
              <Typography mt={1} color={red["500"]}>
                Please select currency type
              </Typography>
            )}
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <InputField1
              errors={errors}
              name="availability"
              type="datetime-local"
              label="Availability *"
              errText="Please enter future availability"
              slotProps={{
                inputProps: {
                  min: moment().format("YYYY-MM-DDTHH:mm")
                },
              }}

              defaultValue={
                specialist?.profile?.availability
                  ? moment(specialist?.profile?.availability).format(
                    "YYYY-MM-DDTHH:mm"
                  )
                  : ""
              }
            />

          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <InputField1
              name="language"
              errors={errors}
              label="Languages Spoken *"
              errText="Please enter languages"
              defaultValue={specialist?.profile?.language || ""}
              placeholder="List the languages you are fluent in."
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <RadioInput1 name="gender" label="Identity *" errors={errors} errText="Please select your identity" defaultValue={specialist?.specialist?.gender || ""}>
              <FormControlLabel value="male" control={<Radio size="small" />} label="Male" />
              <FormControlLabel value="female" control={<Radio size="small" />} label="Female" />
              <FormControlLabel value="others" control={<Radio size="small" />} label="Others" />
            </RadioInput1>
          </Grid>
        </>
        <Address
          errors={errors}
          countryRef={countryRef}
          stateRef={stateRef}
          cityRef={cityRef}
          timezone={timezone}
          persistedData={{
            country: specialist?.address?.country,
            state: specialist?.address?.state,
            city: specialist?.address?.city,
            timeZone: specialist?.profile?.timeZone,
            zip: specialist?.address?.zip
          }}
        />
        {specialist?.experties?.specializationId && <ContactInfo />}

        {!(specialist?.experties?.specializationId === "67d90056c2c4d5ab747f8b43" ||
          specialist?.experties?.specializationId === "695751a16eb048cf622268e5") &&
          SpecializationComponents && (
            <SpecializationComponents
              errors={errors}
              files={files}
              onChangFun={handleSpecializationArea}
            />
          )}

        <>
          <Grid size={12}>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                color: "other.color1",
              }}
            >
              Terms & conditions *
            </Typography>
            <FormControlLabel
              label="I agree to the Terms & Conditions"
              control={
                <Checkbox
                  name="termsCheck"
                  defaultChecked={Boolean(specialist?.profile)}
                />
              }
            />
            {errors?.termsCheck && (
              <Typography mt={1} color={red["500"]}>
                Please accept Terms & Conditions
              </Typography>
            )}
          </Grid>
          <Grid size={12}>
            <Stack spacing={2} direction="row">
              <Button
                sx={{
                  py: 1.2,
                  minWidth: "110px",
                  justifyContent: "center",
                }}
                type="button"
                variant="contained"
                onClick={async () => {
                  await dispatch(getUpdatedDetailsReq());
                  handleChange("background");
                }}
              >
                Back
              </Button>
              <Button
                sx={{
                  py: 1.2,
                  minWidth: "110px",
                  justifyContent: "center",
                }}
                type="submit"
                variant="contained"
              >
                Submit
              </Button>
            </Stack>
          </Grid>
        </>
      </Grid>
    </Box>
  );
}

export default Profile;
